import React from "react";
import "../styles/testo.css";
import Typed from "react-typed";
import av1 from "../asset/img/av1.jpeg";
import av2 from "../asset/img/av2.png";
import av3 from "../asset/img/av3.jpeg";
export default function Testo(){
  return (
    <div>
      <section id="testimonials">
        <h2 className="testimonial-title">
          {" "}
          <Typed
            strings={["What Our Customers Say "]}
            typeSpeed={100}
            backSpeed={50}
            loop
          />
        </h2>
        <div className="testimonial-container container">
          <div className="testimonial-box">
            <div className="star-rating">
              <span className="fa fa-star checked"></span>
              <span className="fa fa-star checked"></span>
              <span className="fa fa-star checked"></span>
              <span className="fa fa-star checked"></span>
              <span className="fa fa-star checked"></span>
            </div>
            <p className="testimonial-text">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat
              est corporis, nemo placeat nesciunt amet!
            </p>
            <div className="customer-detail">
              <div className="customer-photo">
                <img src={av1} alt="" />
              </div>
              <p>John Doe</p>
            </div>
          </div>

          <div className="testimonial-box">
            <div className="star-rating">
              <span className="fa fa-star checked"></span>
              <span className="fa fa-star checked"></span>
              <span className="fa fa-star checked"></span>
              <span className="fa fa-star checked"></span>
              <span className="fa fa-star checked"></span>
            </div>
            <p className="testimonial-text">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat
              est corporis, nemo placeat nesciunt amet!
            </p>
            <div className="customer-detail">
              <div className="customer-photo">
                <img src={av2} alt="" />
              </div>
              <p>Jay Doe</p>
            </div>
          </div>

          <div class="testimonial-box">
            <div class="star-rating">
              <span className="fa fa-star checked"></span>
              <span className="fa fa-star checked"></span>
              <span className="fa fa-star checked"></span>
              <span className="fa fa-star checked"></span>
              <span className="fa fa-star checked"></span>
            </div>
            <p class="testimonial-text">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat
              est corporis, nemo placeat nesciunt amet!
            </p>
            <div className="customer-detail">
              <div className="customer-photo">
                <img src={av3} alt="" />
              </div>
              <p>Jolly Doe</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
